<template>
    <div id="soEditTable">
        <a-modal
                title="Edit Detail"
                :visible="visible"
                width="85%"
                @cancel="cancel"
        >
            <template slot="footer">
                <a-button key="submit" type="primary" @click="editSave">{{ $t('publicLang.Save') }}</a-button>
            </template>

            <a-row type="flex" justify="start" style="margin-bottom: 10px;">
                <a-col>
                    <label>{{ $t('manual.Sku') }}:</label>
                    <a-input :placeholder="$t('publicLang.PleaseEnter')"  size="small" style="width: 120px;margin-left: 3px;" v-model="skuVal"/></a-col>
                <a-col style="margin: 0 10px">
                    <label>{{ $t('manual.Status') }}:</label>
                    <a-select style="width: 120px;margin-left: 3px;" size="small" :placeholder="$t('publicLang.PleaseSelect')" v-model="statusValue" allowClear>
                        <a-select-option v-for="item in statusSelect" :value="item.code">{{ item.value }}</a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    <a-button type="primary" size="small" @click="init">{{ $t('publicLang.Search') }}</a-button>
                </a-col>
            </a-row>
            <vxe-table
                    stripe
                    highlight-hover-row
                    border
                    resizable
                    show-overflow
                    ref="editTableSo"
                    :edit-config="{trigger: 'click', mode: 'row',key: 'uid'}"
                    size="mini"
                    :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column  show-header-overflow="ellipsis" show-overflow="ellipsis" field="batchNo"  :title="$t('manual.BatchNo')" minWidth="80" sortable></vxe-table-column>
                <vxe-table-column  show-header-overflow="ellipsis" show-overflow="ellipsis" field="lineNo" :title="$t('batchReceive.Line')" minWidth="80" sortable ></vxe-table-column>
                <vxe-table-column  show-header-overflow="ellipsis" show-overflow="ellipsis" field="sku" :title="$t('batchReceive.SKU')" minWidth="180" sortable></vxe-table-column>
                <vxe-table-column  show-header-overflow="ellipsis" show-overflow="ellipsis" field="status" :title="$t('batchReceive.Status')" minWidth="80"></vxe-table-column>
                <vxe-table-column show-header-overflow show-overflow field="soQty" :title="$t('pubGicSet.soQty')" width="150" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }">
                        <a-input-number v-model="row.soQty"  size="small" :placeholder="$t('publicLang.PleaseEnter')"/>
                    </template>
                    <template v-slot="{ row }">{{ row.soQty }}</template>
                </vxe-table-column>
                <vxe-table-column v-if="false" show-header-overflow show-overflow field="allocationRule01" title="ALLOCATION_RULE_01 " width="220" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }">
                        <a-select style="width: 120px;margin-left: 3px;" size="small" :placeholder="$t('publicLang.PleaseSelect')" v-model="row.allocationRule01" allowClear>
                            <a-select-option v-for="item in allRuleList" :value="item.CODE">{{ item.CODE_DESC }}</a-select-option>
                        </a-select>
                    </template>
                    <template v-slot="{ row }">{{ row.allocationRule01 }}</template>
                </vxe-table-column>
                <vxe-table-column v-if="false" show-header-overflow show-overflow field="allocationRule02" title="ALLOCATION_RULE_02" width="220" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }">
                        <a-select style="width: 120px;margin-left: 3px;" size="small" :placeholder="$t('publicLang.PleaseSelect')" v-model="row.allocationRule02" allowClear>
                            <a-select-option v-for="item in allRuleList" :value="item.CODE">{{ item.CODE_DESC }}</a-select-option>
                        </a-select>
                    </template>
                    <template v-slot="{ row }">{{ row.allocationRule02 }}</template>
                </vxe-table-column>
            </vxe-table>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                visible: false,
                skuVal: null,
                statusValue: undefined,
                statusSelect: [],
                tableData: [],
                allRuleList: [],
                soHeaderUid: ''
            }
        },
        methods:{
            show(uid){
                this.visible = true
                this.soHeaderUid = uid
                this.init()
            },
            cancel(){
                this.visible = false
            },
            init(){
                let params = {
                    sku: this.skuVal,
                    soHeaderUid: this.soHeaderUid,
                    status: this.statusValue
                }
                ajax.post(api.SOEDITORSODETAIL,params).then(res=>{
                    this.statusSelect = res.data.soStatusList
                    this.tableData = res.data.soDetailList
                    this.allRuleList = res.data.allRuleList
                })
            },
            //            校验
           editSave(){
               let params = {
                   batchEditorDataDtos: this.tableData
               }
               ajax.post(api.SOSAVESODETAIL,params).then(res=>{
                   if(res.code == 200){
                       this.$message.success(res.msg);
                       this.$emit('cancelImport',"init")
                   }
               })
           }
        }
    }
</script>